import React, { Component } from 'react';
import { Row, Col, Modal } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import moment from "moment";
import "./_singleRequest.scss";
import "./_studentPermission.scss";


const ADD_CREATE_GROUP_WISE_PERMISSIONS = gql`
  mutation($params: AddPermissionDetails) {
    createGroupWisePermissions(params: $params)
  }`;

// ── Finance-style multi-select checkbox dropdown ──────────────────────────────
class CheckboxDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.ref = React.createRef();
    }

    componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
    componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }

    handleOutside = (e) => {
        if (this.ref.current && !this.ref.current.contains(e.target))
            this.setState({ open: false });
    };

    toggle = (id) => {
        const { value, onChange } = this.props;
        const exists = value.includes(id);
        onChange(exists ? value.filter((v) => v !== id) : [...value, id]);
    };

    render() {
        const { options, value, placeholder, onChange } = this.props;
        const { open } = this.state;
        const label = value.length === 0
            ? placeholder
            : value.length === options.length
                ? `All (${options.length})`
                : value.length === 1
                    ? options.find((o) => o.value === value[0])?.label || `${value.length} selected`
                    : `${value.length} selected`;

        return (
            <div ref={this.ref} style={{ position: "relative" }}>
                <div onClick={() => this.setState({ open: !open })}
                    style={{ borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "10px 12px", fontSize: 13, color: value.length ? "#1f2937" : "#9ca3af", background: "#f9fafb", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none" }}>
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                    <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
                </div>

                {open && (
                    <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 220, overflowY: "auto" }}>
                        {options.length === 0 ? (
                            <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
                        ) : (
                            <>
                                <div onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))}
                                    style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}>
                                    <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />
                                    Select All
                                </div>
                                {options.map((o) => (
                                    <div key={o.value} onClick={() => this.toggle(o.value)}
                                        style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}>
                                        <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                                        <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

class MultipleRequestModal extends Component {
    constructor() {
        super();
        this.state = {
            branchSearch: "0",
            branchError: "",
            classError: "",
            classSearch: [],
            sectionError: "",
            sectionSearch: [],
            fromDate: "",
            fromDateError: "",
            toDate: "",
            toDateError: "",
            dataClear: 0,
            requestMessage: "",
            loader: 0,
            submitError: "",
            submitted: false,
            eventName: "",
            eventError: ""
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.resetForm();
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 });
        }
        // branches arrived after first render — set defaults
        if (this.props.show === true && this.state.branchSearch === "0" && (this.props.branches || []).length > 0) {
            this.applyBranch(this.props.branches[0].id);
        }
    }

    resetForm = () => {
        const branches = this.props.branches || [];
        this.setState({
            classError: "", sectionError: "", branchError: "",
            fromDate: "", fromDateError: "", toDate: "", toDateError: "",
            dataClear: 1, requestMessage: "", loader: 0,
            submitError: "", submitted: false, eventName: "", eventError: "",
            classSearch: [], sectionSearch: [],
            branchSearch: branches.length > 0 ? branches[0].id : "0",
        }, () => {
            if (branches.length > 0) this.applyBranch(branches[0].id);
        });
    }

    // sets branch + selects all classes/sections under that branch
    applyBranch = (branchId) => {
        const branchObj = (this.props.branches || []).find(b => String(b.id) === String(branchId));
        const sections = branchObj ? (branchObj.sections || []) : [];
        const classIds = Array.from(new Set(sections.map(s => Number(s.class_id))));
        const sectionIds = sections.map(s => s.id);
        this.setState({
            branchSearch: branchId,
            branchError: "",
            classSearch: classIds,
            sectionSearch: sectionIds,
        });
    }

    selecthandleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "fromDate") this.setState({ fromDateError: "" });
        if (name === "toDate") this.setState({ toDateError: "" });
        if (name === "eventName") this.setState({ eventError: "" });
        this.setState({ [name]: value });
    }

    handleBranchChange = (e) => {
        this.applyBranch(e.target.value);
    }

    handleFormSubmit = () => {
        if (this.state.eventName.trim() === "") {
            this.setState({ eventError: "Event name is required." }); return;
        }
        if (this.state.eventName.trim().length < 3) {
            this.setState({ eventError: "Event name must be at least 3 characters." }); return;
        }
        if (this.state.branchSearch === "0") {
            this.setState({ branchError: "Please select a branch." }); return;
        }
        if (!this.state.classSearch.length) {
            this.setState({ classError: "Please select at least one class." }); return;
        }
        if (!this.state.sectionSearch.length) {
            this.setState({ sectionError: "Please select at least one section." }); return;
        }
        if (this.state.fromDate === "") {
            this.setState({ fromDateError: "From date & time is required." }); return;
        }
        if (this.state.toDate === "") {
            this.setState({ toDateError: "To date & time is required." }); return;
        }
        if (moment(this.state.toDate).isSameOrBefore(moment(this.state.fromDate))) {
            this.setState({ toDateError: "To date must be after the from date." }); return;
        }

        this.setState({ loader: 1, submitError: "" });

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: this.state.branchSearch.toString(),
            class_id: this.state.classSearch.map(i => i).toString(),
            section_id: this.state.sectionSearch.map(i => i).toString(),
            from_datetime: moment(this.state.fromDate, 'YYYY-MM-DD HH:mm:ss').unix().toString(),
            to_datetime: moment(this.state.toDate, 'YYYY-MM-DD HH:mm:ss').unix().toString(),
            request_message: this.state.requestMessage,
            request_title: this.state.eventName.toString(),
            approved_by: parseInt(Cookies.get("id"))
        };

        this.createGroupWisePermissions(params).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message).join(", "),
                loader: 0
            });
        });
    };

    createGroupWisePermissions = async (params) => {
        await this.props.createGroupWisePermissions({
            variables: { params },
            update: (store, { data }) => {
                if (data.createGroupWisePermissions) {
                    this.setState({ loader: 0, submitted: true });
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }
        });
    };

    render() {
        const branches = this.props.branches || [];
        const getClasses = this.props.getClasses || [];

        const branchObj = branches.find(b => String(b.id) === String(this.state.branchSearch));
        const branchSections = branchObj ? (branchObj.sections || []) : [];

        const classOptions = Array.from(new Set(branchSections.map(s => Number(s.class_id))))
            .map(cid => getClasses.find(c => c.id === cid)).filter(Boolean)
            .map(c => ({ value: c.id, label: c.class }));

        const sectionOptions = branchSections
            .filter(s => this.state.classSearch.length === 0 || this.state.classSearch.map(Number).includes(Number(s.class_id)))
            .map(s => ({ value: s.id, label: s.section_name }));

        const selectStyle = { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "10px 12px", fontSize: 13, color: "#1f2937", background: "#f9fafb", width: "100%", height: 44 };

        return (
            <Modal {...this.props} size="lg" aria-labelledby="multi-request-modal">
                <Modal.Header closeButton className="perm-modal-header-neutral" style={{ borderBottom: "none" }}>
                    <Modal.Title className="modal-title">
                        <i className="fas fa-users mr-2" />Multi Request
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ background: "#F8FAFC", padding: "28px 28px 20px" }}>
                    {/* ── Event Name ── */}
                    <div style={{ background: "#fff", borderRadius: 12, padding: "20px 20px 14px", marginBottom: 18, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                        <p className="perm-section-heading"><i className="fas fa-tag mr-1" />Event Details</p>
                        <Row>
                            <Col lg={6} sm={12}>
                                <label className="perm-input-label">Event Name <span className="req">*</span></label>
                                <input
                                    type="text"
                                    className={`perm-input${this.state.eventError ? " is-invalid" : ""}`}
                                    placeholder="e.g. Diwali Holidays, Annual Sports Day"
                                    name="eventName"
                                    onChange={this.selecthandleInputChange}
                                    value={this.state.eventName}
                                />
                                {this.state.eventError && (
                                    <span className="perm-error-text"><i className="fas fa-exclamation-circle" />{this.state.eventError}</span>
                                )}
                            </Col>
                        </Row>
                    </div>

                    {/* ── Filters ── */}
                    <div style={{ background: "#fff", borderRadius: 12, padding: "20px 20px 14px", marginBottom: 18, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                        <p className="perm-section-heading"><i className="fas fa-filter mr-1" />Target Students</p>
                        <Row>
                            <Col lg={4} sm={12} className="mb-3">
                                <label className="perm-input-label">Branch <span className="req">*</span></label>
                                <select
                                    style={selectStyle}
                                    value={this.state.branchSearch}
                                    onChange={this.handleBranchChange}
                                >
                                    <option value="0" disabled>Select Branch</option>
                                    {branches.map((b) => (
                                        <option key={b.id} value={b.id}>{b.branch_name}</option>
                                    ))}
                                </select>
                                {this.state.branchError && (
                                    <span className="perm-error-text"><i className="fas fa-exclamation-circle" />{this.state.branchError}</span>
                                )}
                            </Col>
                            <Col lg={4} sm={12} className="mb-3">
                                <label className="perm-input-label">Class <span className="req">*</span></label>
                                <CheckboxDropdown
                                    options={classOptions}
                                    value={this.state.classSearch}
                                    onChange={(val) => {
                                        if (val.length === 0) {
                                            this.setState({ classSearch: [], sectionSearch: [], classError: "" });
                                            return;
                                        }
                                        const newSectionIds = branchSections
                                            .filter(s => val.map(Number).includes(Number(s.class_id)))
                                            .map(s => s.id);
                                        this.setState({ classSearch: val, sectionSearch: newSectionIds, classError: "" });
                                    }}
                                    placeholder="Select Class(es)"
                                />
                                {this.state.classError && (
                                    <span className="perm-error-text"><i className="fas fa-exclamation-circle" />{this.state.classError}</span>
                                )}
                            </Col>
                            <Col lg={4} sm={12} className="mb-3">
                                <label className="perm-input-label">Section <span className="req">*</span></label>
                                <CheckboxDropdown
                                    options={sectionOptions}
                                    value={this.state.sectionSearch}
                                    onChange={(val) => this.setState({ sectionSearch: val, sectionError: "" })}
                                    placeholder="Select Section(s)"
                                />
                                {this.state.sectionError && (
                                    <span className="perm-error-text"><i className="fas fa-exclamation-circle" />{this.state.sectionError}</span>
                                )}
                            </Col>
                        </Row>
                    </div>

                    {/* ── Dates + Message + Submit ── */}
                    <div style={{ background: "#fff", borderRadius: 12, padding: "20px 20px 14px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                        <p className="perm-section-heading"><i className="fas fa-calendar-alt mr-1" />Permission Period</p>
                        <Row>
                            <Col lg={6} sm={12} className="mb-3">
                                <label className="perm-input-label">From Date & Time <span className="req">*</span></label>
                                <input
                                    type="datetime-local"
                                    name="fromDate"
                                    className={`perm-input${this.state.fromDateError ? " is-invalid" : ""}`}
                                    onChange={this.selecthandleInputChange}
                                    value={this.state.fromDate}
                                    style={{ height: "44px" }}
                                />
                                {this.state.fromDateError && (
                                    <span className="perm-error-text"><i className="fas fa-exclamation-circle" />{this.state.fromDateError}</span>
                                )}
                            </Col>
                            <Col lg={6} sm={12} className="mb-3">
                                <label className="perm-input-label">To Date & Time <span className="req">*</span></label>
                                <input
                                    type="datetime-local"
                                    name="toDate"
                                    className={`perm-input${this.state.toDateError ? " is-invalid" : ""}`}
                                    onChange={this.selecthandleInputChange}
                                    min={this.state.fromDate || undefined}
                                    value={this.state.toDate}
                                    style={{ height: "44px" }}
                                />
                                {this.state.toDateError && (
                                    <span className="perm-error-text"><i className="fas fa-exclamation-circle" />{this.state.toDateError}</span>
                                )}
                            </Col>
                            <Col lg={12} sm={12} className="mb-3">
                                <label className="perm-input-label">Request Message <span style={{ color: "#94A3B8", fontWeight: 400, textTransform: "none" }}>(optional)</span></label>
                                <textarea
                                    className="perm-input"
                                    name="requestMessage"
                                    rows={3}
                                    placeholder="Add a note for this request..."
                                    onChange={this.selecthandleInputChange}
                                    value={this.state.requestMessage}
                                />
                            </Col>
                        </Row>

                        <Row className="mt-2">
                            <Col sm={12} className="d-flex align-items-center" style={{ gap: 14, flexWrap: "wrap", justifyContent: "flex-end" }}>
                                <button className="btn-perm-submit" onClick={this.handleFormSubmit} disabled={this.state.loader === 1}>
                                    {this.state.loader === 1
                                        ? <span className="spinner-border spinner-border-sm" />
                                        : <i className="fas fa-paper-plane" />
                                    }
                                    Send Request
                                </button>

                                {this.state.submitted && (
                                    <div className="perm-alert perm-alert-success">
                                        <i className="fas fa-check-circle" />Multi-request sent successfully!
                                    </div>
                                )}
                                {this.state.submitError && (
                                    <div className="perm-alert perm-alert-error">
                                        <i className="fas fa-exclamation-circle" />{this.state.submitError}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default withRouter(compose(
    graphql(ADD_CREATE_GROUP_WISE_PERMISSIONS, { name: "createGroupWisePermissions" })
)(MultipleRequestModal));
